import { DynamicClientComponent } from "../DynamicClientComponent";
import { ScrollToTop } from "./ScrollToTop";
import { FloatingWhatsApp } from "./FloatingWhatsApp";

/**
 * Layout principal que envuelve todas las páginas
 * Carga Navbar y Footer dinámicamente según el tenant
 */
export const MainLayout = ({ children }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ScrollToTop />

      {/* Navbar dinámico según cliente */}
      <DynamicClientComponent componentName="Navbar" />

      {/* Contenido principal */}
      <main style={{ flex: 1 }}>
        {children}
      </main>

      {/* Footer dinámico según cliente */}
      <DynamicClientComponent componentName="Footer" />

      <FloatingWhatsApp />
    </div>
  );
};
